import * as PropTypes from 'prop-types';

export default function SuccessIcon(props) {
  return (
    <svg width="116" height="116" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <circle fill="#FFF" cx="58" cy="59" r="51" />
        <path d="M58 116C25.967 116 0 90.033 0 58S25.967 0 58 0s58 25.967 58 58-25.967 58-58 58zm30.775-85L46.386 73.514 27.22 54.315 19 62.563 46.392 90 97 39.242 88.775 31z" fill={props.fill} />
      </g>
    </svg>
  );
}

SuccessIcon.propTypes = {
  fill: PropTypes.string.isRequired,
};
